import type { ConfigType } from '@plone/registry';
import { defineMessages } from 'react-intl';
import StandardWrapper from '@plone/volto/components/manage/Toolbar/StandardWrapper';
import RestaurantJsonLd from '../components/SEO/RestaurantJsonLd';
import MetaTags from '../components/SEO/MetaTags';
import MenuJsonLd from '../components/SEO/MenuJsonLd';
import AIImageTool from '../components/AIImageTool/AIImageTool';
import AIToolbarButton from '../components/AIImageTool/AIToolbarButton';
import PageTransition from '../components/Theme/PageTransition/PageTransition';
import MatomoTracker from '../components/Analytics/MatomoTracker';
import { restaurantSettingsAsyncPropExtender } from '../actions/restaurantSettings';
import restaurantSettings from '../reducers/restaurantSettings';

const messages = defineMessages({
  aiImage: {
    id: 'AI Image',
    defaultMessage: 'Image IA',
  },
});

export default function install(config: ConfigType) {
  // Volto reads the site language from the backend. This list only sets
  // the locales that go into the build.
  config.settings.supportedLanguages = ['fr'];
  // The pages do not show their related items.
  config.settings.showRelatedItems = false;

  // Inner pages read "Carte · Restaurant À Ciel Ouvert". The home page keeps
  // the site title alone. Volto reads the separator from the top-level key.
  config.settings.siteTitleFormat = {
    ...(config.settings as any).siteTitleFormat,
    includeSiteTitle: true,
    titleAndSiteTitleSeparator: '·',
  };
  (config.settings as any).titleAndSiteTitleSeparator = '·';

  (config as any).addonReducers = {
    ...((config as any).addonReducers || {}),
    restaurantSettings,
  };
  (config.settings as any).asyncPropsExtenders = [
    ...((config.settings as any).asyncPropsExtenders || []),
    restaurantSettingsAsyncPropExtender,
  ];

  config.settings.pluggableStyles = [
    ...((config.settings as any).pluggableStyles || []),
    {
      id: 'accent-none',
      title: 'Sans fond',
      cssClass: 'accent-none',
    },
    {
      id: 'accent-lin',
      title: 'Fond lin (chaud)',
      cssClass: 'accent-lin',
    },
    {
      id: 'accent-pierre',
      title: 'Fond pierre (neutre)',
      cssClass: 'accent-pierre',
    },
    {
      id: 'accent-foret',
      title: 'Fond forêt (sombre)',
      cssClass: 'accent-foret',
    },
    {
      id: 'accent-encre',
      title: 'Fond encre (très sombre)',
      cssClass: 'accent-encre',
    },
  ];

  config.settings.additionalToolbarComponents = {
    ...(config.settings.additionalToolbarComponents || {}),
    aiImage: {
      component: AIImageTool,
      wrapper: StandardWrapper,
      wrapperTitle: messages.aiImage,
      hideToolbarBody: true,
    },
  };

  config.settings.appExtras = [
    ...((config.settings as any).appExtras || []),
    {
      match: '/',
      component: RestaurantJsonLd,
    },
    {
      match: '/',
      component: MetaTags,
    },
    {
      match: '/',
      component: MenuJsonLd,
    },
    {
      match: '/',
      component: AIToolbarButton,
    },
    {
      match: '/',
      component: PageTransition,
    },
    {
      match: '/',
      component: MatomoTracker,
    },
  ];

  return config;
}
